<template>
  <div class="navigation" :class="{ 'nav-opened': navOpen }">
    <div class="navigation-shell d-flex flex-column justify-content-between">
      <div>
        <div class="navigation-button menu-button" @click="toggleNav()">
          <div class="copy" id="title">
            <span class="">The Portal</span>
          </div>
          <div class="icon menu" style="color: #fff">
            <!-- <span v-if="navOpen" class="mdi mdi-backburger"></span>
            <span v-else class="mdi mdi-menu"></span> -->
            <!-- <img src="../assets/team.png" height="30" width="45" alt=""> -->
            <img :src="newIcon" class="new-icon" alt="" />
          </div>
        </div>
        <div v-for="btn in nonellipsesbtns" :key="btn.title">
          <div
            class="nav-holder"
            v-if="
              checkPermission(btn.title, btn.permission)
            "
            >
              <NavigationButton
                :title="btn.title[0].toUpperCase()+btn.title.slice(1)"
                classStyle="icon"
                @mouseover="getPos(btn.title[0].toLowerCase()+btn.title.slice(1))"
                @mouseout="removePopUp()"
                :routeName="routeNames[btn.title]"
                :icon="btn.icon"
                :leaves="this.leaveCounter"
                @click="goToRoute(routeNames[btn.title])"
              />
          </div>
        </div>
        
        <!-- <div
          class="nav-holder"
          v-if="
            this.permissions.includes('Leave-Admin') ||
            this.permissions.includes('Executive') ||
            this.reportee_count > 0
          "
        >
          <NavigationButton
            title="Team"
            class="ellipses-icons"
            classStyle="ellipsesIcon"
            ellipsesCopy="ellipsesCopy"
            @mouseover="getPos('team')"
            @mouseout="removePopUp()"
            :routeName="routeNames.team"
            :icon="'mdi-bell'"
            :leaves="this.leaveCounter"
            @click="goToRoute(routeNames.team)"
          />
        </div> -->

        <div v-if="showEllipses">
          <div class="nav-holder">
            <NavigationButton
              title="More"
              class="icons"
              classStyle="icon"
              @mouseover="getPos('more')"
              @mouseout="removePopUp()"
              :leaves="this.leaveCounter"
              :moreHasNotification="this.moreHasNotification"
              :icon="'mdi mdi-dots-horizontal dots-icon'"
              @click="toggleEllipsesActive"
            />
          </div>
        </div>

      </div>

      <div>
        <div class="nav-holder">
          <NavigationButton
            class="icons"
            classStyle="icon"
            @mouseover="getPos('userProfile')"
            @mouseout="removePopUp()"
            title="User Profile"
            :routeName="routeNames.userProfile"
            :icon="'mdi-account-circle'"
            :image="this.emp_img"
            :bgColor="this.emp_bg"
            :initials="this.emp_initials"
            @click="goToRoute(routeNames.userProfile)"
          />
        </div>
        <div class="nav-holder">
          <NavigationButton
            class="icons"
            classStyle="icon"
            @mouseover="getPos('help')"
            @mouseout="removePopUp()"
            title="Help"
            :routeName="routeNames.help"
            :icon="'mdi-help-circle-outline'"
            @click="goToRoute(routeNames.help)"
          />
        </div>
        <div class="nav-holder">
          <NavigationButton
            title="Log Out"
            classStyle="icon"
            :icon="'mdi-logout'"
            @click="logout"
          />
        </div>
      </div>
    </div>
  </div>
  <div
    class="popup-modal"
    id="popup-modal"
    :style="`top: ${popupTop}; bottom: ${popupBottom}`"
  >
    <div class="arrow-left"></div>
    <div class="popup-text">{{ popupText }}</div>
  </div>

  <div id="ellipses" class="ellipses" :class="{'nav-open': navOpen}" v-show="ellipsesActive">
    <div style="height: 100%;" v-for="btn in ellipsesbtns" :key="btn.title">
      <div
      class="nav-holder"
      v-if="
        checkPermission(btn.title, btn.permission)
      "
      >
      <NavigationButton
        :title="btn.title[0].toUpperCase()+btn.title.slice(1)"
        class="ellipses-icons"
        classStyle="ellipsesIcon"
        ellipsesCopy="ellipsesCopy"
        :routeName="routeNames[btn.title]" 
        :icon="btn.icon"
        :leaves="this.leaveCounter"
        :moreHasNotification="this.moreHasNotification"
        @click="goToRoute(routeNames[btn.title])"
      />
      </div>

    </div>
    
  </div>
</template>

<script>
import { routeNames } from '../js/routeNames';
import NavigationButton from './NavigationButton.vue';
import { decryptData } from '../js/utils/encrypt';
import Icon from '../assets/Portal_Logo.png';
import axios from 'axios';
import { deleteCookie, removeAllLocalStorage } from '../js/composables';
export default {
  name: 'Navigation',
  components: {
    NavigationButton,
  },
  computed: {
    routeNames: () => {
      routeNames.user = 'manage-user';
      routeNames.role = 'manage-role';
      routeNames.info = 'myinfo';
      routeNames.people = 'people';
      routeNames.audits = 'report';
      routeNames.report = 'employee-report';
      routeNames.file = 'folder';
      routeNames['File Upload'] = 'fileupload';
      routeNames.announce = 'announcements';
      routeNames['Leaves Adjust'] = 'leaves';
      routeNames['pM'] = 'viewperformancemanagement';


      return routeNames;
    },
    leaveCounter() {
      return this.leaveCount;
    },
  },
  inject: ['leaveCount'],
  watch: {
    leaveCounter(newValue) {
      if (newValue > 0) {
        this.showNotificationBell = true;
      } else {
        this.showNotificationBell = false;
      }
    },
  },
  data() {
    return {
      window: {
        width: 0,
        height: 0,
      },
      navOpen: false,
      permissions: [],
      loggedInUser: [],
      employees: [],
      email: '',
      popupTop: '0px',
      popupText: '',
      popupBottom: '0px',
      newIcon: Icon,
      tooltipPos: [
        { popupTop: '76', popupBottom: '0' },
        { popupTop: '125', popupBottom: '0' },
        { popupTop: '175', popupBottom: '0' },
        { popupTop: '224', popupBottom: '0' },
        { popupTop: '276', popupBottom: '0' },
        { popupTop: '325', popupBottom: '0' },
        { popupTop: '326', popupBottom: '0' },
        { popupTop: '427', popupBottom: '0' },
        { popupTop: '478', popupBottom: '0' },
        { popupTop: '525', popupBottom: '0' },
        { popupTop: '575', popupBottom: '0' },
        { popupTop: '325', popupBottom: '0' },
        { popupTop: '375', popupBottom: '0' },
        { popupTop: 'auto', popupBottom: '125' },
        { popupTop: 'auto', popupBottom: '76' },
      ],
      iconsname: [
        { title: 'user', popuptext: 'Manage User', permission: 'View-User', icon: 'mdi-account-multiple-plus' },
        { title: 'role', popuptext: 'Manage Role', permission: 'View-Role', icon: 'mdi-account-cog' },
        { title: 'home', popuptext: 'Home', permission: 'Viewer', icon: 'mdi-card-account-details-outline' },
        { title: 'info', popuptext: 'My Info', permission: 'Viewer', icon: 'mdi-information-outline' },
        { title: 'people', popuptext: 'People', permission: 'Viewer', icon: 'mdi-account-group' },
        { title: 'file', popuptext: 'Files', permission: 'Viewer', icon: 'mdi-file-account' },
        { title: 'audits', popuptext: 'Audits', permission: 'View-Audit', icon: 'mdi-file-chart' },
        { title: 'report', popuptext: 'Reports', permission: 'View-Report', icon: 'mdi-chart-box' },
        { title: 'team', popuptext: 'Team', permission: 'Viewer', icon: 'mdi-bell' },
        // { title: 'file', popuptext: 'Files', permission: 'Viewer', icon: 'mdi-file-account' },
        { title: 'File Upload', popuptext: 'Files Upload', permission: 'File-Access-Permission', icon: 'mdi-file-upload'},
        { title: 'announce', popuptext: 'Announcement', permission: 'Announcement-Permission', icon: 'mdi mdi-bullhorn'},
        { title: 'Leaves Adjust', popuptext: 'Leaves', permission: 'Leave-Admin', icon: 'mdi-table-cog' },
        { title: 'pM', popuptext: 'PM', permission: 'Viewer', icon: 'mdi-chart-line' },
        { title: 'more', popuptext: 'More', permission: 'Viewer', icon: 'mdi mdi-dots-horizontal dots-icon' },
        {
          title: 'userProfile',
          popuptext: 'User Profile',
          permission: 'Viewer',
        },
        { title: 'help', popuptext: 'Help', permission: 'Viewer' },
      ],
      currentbtns: [],
      ellipsesbtns: [],
      nonellipsesbtns: [],
      emp_img: null,
      emp_bg: '',
      emp_initials: '',
      reportee_count: '',
      empId: '',
      showNotificationBell: false,
      // leaveCounter: this.leaveCount,
      scrollTop: 0,
      ellipsesActive: false,
      showEllipses: false,
      moreHasNotification: false,
    };
  },
  mounted() {
    //Decrypting Permissions
    let mkLocalData = localStorage.getItem('Permissions');
    if (!mkLocalData) {
      mkLocalData = 'null';
    }
    const secretPermissionKey = process.env.KEY || 'myscecretkey';
    this.permissions = decryptData(mkLocalData, secretPermissionKey);
    this.currentbtns = this.iconsname.filter((element) =>
      this.permissions.includes(element.permission)
    );

    var encryptedEmailID = localStorage.getItem('Email');
    var encryptedEmpID = localStorage.getItem('EmployeeID');
    this.email = decryptData(encryptedEmailID, secretPermissionKey).replace(
      /['"]+/g,
      ''
    );
    this.empId = decryptData(encryptedEmpID, secretPermissionKey).replace(
      /['"]+/g,
      ''
    );

    if (this.email != 'admin@scala.com') {
      this.getEmployeeInfoByEmail();
    } else {
      this.setButtons();
    }
    
    var sidebar = document.getElementsByClassName('navigation')[0];
    sidebar.addEventListener('scroll', () => {
      this.scrollTop = sidebar.scrollTop;
    });
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  unmounted() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    async getEmployeeInfoByEmail() {
      await axios
        .get(this.$hostName + `/employeeinfobyemail/${this.email}`)
        .then((response) => {
          response.data.forEach((element) => {
            this.loggedInUser.push(element);
          });
          this.reportee_count = this.loggedInUser[0]['reportee_count'];
          this.emp_img = this.loggedInUser[0]['profile_pic'];
          if (this.loggedInUser[0]['profile_pic'] == null)
            this.emp_img = 'noimage';
          this.emp_bg = this.loggedInUser[0]['imageBackgroundColour'];
          this.emp_initials = this.loggedInUser[0]['employeeShortName'];

          this.setButtons();
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    setButtons() {
      this.currentbtns = this.currentbtns.filter(each => {
      // each.title !== 'userProfile' || each.title !== 'help' || each.title !== 'team' || each.title !== 'more';
      if((each.title !== 'userProfile' && each.title !=='help' && each.title !== 'more') || each.title == 'team') {
        if(each.title == 'team') {
          if(this.permissions.includes('Leave-Admin') || this.permissions.includes('Executive') || this.reportee_count > 0) {
            return true;
          } else {
            return false;
          }
        }
        return true;
      }
        return true;
      });

      this.ellipsesbtns = this.currentbtns.slice(5, -3).filter(each => each.title != 'more');
      this.nonellipsesbtns = this.currentbtns.slice(0, 5).filter(each => each.title != 'more');
      

      if(this.ellipsesbtns.some(item => item.title == 'team')) {
        this.moreHasNotification = true;
      }

      if (this.currentbtns.length > 5 && this.ellipsesbtns.length > 0) {
      this.showEllipses = true;
      // this.populateEllipses();
      } else {
        this.currentbtns = this.currentbtns.filter(ele => ele.title !== 'more');
        this.showEllipses = false;
        // this.dontShowEllipses = true;
      }
    },

    checkPermission(title, perm){
      if(title != 'team') {
        if(this.permissions.includes(perm)){
          return true;
        }
      } else if(title =='team') {
        if(this.permissions.includes('Leave-Admin') || this.permissions.includes('Executive') || this.reportee_count>0){
          return true;
        } else {
          return false;
        }
      }

    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    removePopUp() {
      var removeOpacity = document.getElementById('popup-modal');
      removeOpacity.classList.remove('show');
    },

    getPos(type) {
      var addOpacity = document.getElementById('popup-modal');
      addOpacity.classList.add('show');
      if(type == 'more') {
        this.set_popup_pos(
          325, 0, 'More'
        );
      } else if (
        (this.window.height < 600 && this.currentbtns.length >= 9) ||
        (type != 'userProfile' && type != 'help')
      ) {
        for (const key in this.currentbtns) {
          if (this.currentbtns[key].title == type) {
            this.set_popup_pos(
              this.tooltipPos[key].popupTop,
              this.tooltipPos[key].popupBottom,
              this.currentbtns[key].popuptext
            );
            break;
          }
        }
      } else {
        if (type == 'userProfile') {
          this.set_popup_pos(
            this.tooltipPos[this.tooltipPos.length - 2].popupTop,
            this.tooltipPos[this.tooltipPos.length - 2].popupBottom,
            this.iconsname[this.iconsname.length - 2].popuptext
          );
        } else if (type == 'help') {
          this.set_popup_pos(
            this.tooltipPos[this.tooltipPos.length - 1].popupTop,
            this.tooltipPos[this.tooltipPos.length - 1].popupBottom,
            this.iconsname[this.iconsname.length - 1].popuptext
          );
        }
      }
    },
    set_popup_pos(top, bottom, title) {
      if (top != 'auto') {
        this.popupTop = parseInt(top) - this.scrollTop + 'px';
      } else {
        this.popupTop = top;
      }
      this.popupBottom = parseInt(bottom) + this.scrollTop + 'px';
      this.popupText = title;
    },
    goToRoute(route) {
      
      this.$emit('checkAthentication');
      if (this.navOpen) this.toggleNav();
      if (this.ellipsesActive) this.toggleEllipsesActive();
      if (route == this.$router.currentRoute.name) return;

      this.$router.push({ name: route });
    },
    toggleNav() {
      this.navOpen = !this.navOpen;
      this.$emit('navOpen', this.navOpen);
    },
    logout() {
      axios
        .post(this.$hostName + '/logout', null)
        .then(() => {
          deleteCookie('token');
          deleteCookie('2faToken');
          removeAllLocalStorage();
          this.$router.push({ path: '/' });
        })
        .catch((error) => {
          deleteCookie('token');
          deleteCookie('2faToken');
          removeAllLocalStorage();
          this.errors = error.response.data.errors;
        })
        .finally(() => {});
    },
    toggleEllipsesActive() {
      this.removePopUp();
      this.ellipsesActive = !this.ellipsesActive;
    },
    closeEllipses() {
      this.removePopUp();
      this.ellipsesActive = false;
    },
    populateEllipses() {
      let ellipses = document.getElementById('ellipses');
      for(let each of this.currentbtns) {
        console.log(each);
        let htmlString = `<div
              class="nav-holder"
              v-if="
                this.permissions.includes('Leave-Admin') ||
                this.permissions.includes('Executive') ||
                this.reportee_count > 0
              "
            >
              <NavigationButton
                title="Team"
                class="ellipses-icons"
                classStyle="ellipsesIcon"
                ellipsesCopy="ellipsesCopy"
                :routeName="routeNames.team"
                :icon="'mdi-bell'"
                :leaves="this.leaveCounter"
                @click="goToRoute(routeNames.team)"
              />
            </div>`;

        let child = document.createElement('div');
        child.innerHTML = htmlString;
        ellipses.appendChild(child);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.new-icon {
  height: 45px;
  width: 45px;
}
@media only screen and (max-width: 575.98px) {
  .popup-modal {
    display: none;
  }
}
@media (min-width: 768px) and (max-width: 991.98px) {
  .popup-modal {
    display: none;
  }
}
.menus {
  margin-left: 36%;
  color: #7a7a7a;
  text-decoration: none;
}
.arrow-left {
  width: 0;
  height: 0;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
  position: absolute;
  top: 8px;
  left: -9px;
  border-right: 10px solid #ee3234;
}
.popup-modal {
  font-family: "Montserrat";
  background: #ee3234;
  position: fixed;
  border-radius: 10px;
  width: 120px;
  left: 69px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  opacity: 0;
  font-size: 0.9em;
}

.show {
  z-index: 1000;
  -webkit-animation: fadein 0.5s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 0.5s; /* Firefox < 16 */
  -ms-animation: fadein 0.5s; /* Internet Explorer */
  -o-animation: fadein 0.5s; /* Opera < 12.1 */
  animation: fadein 0.5s;
  animation-fill-mode: forwards;
}
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Internet Explorer */
@-ms-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Opera < 12.1 */
@-o-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.popup-text {
  color: white;
}
.nav-holder:hover .popup-modal {
  opacity: 1;
}
.menus:hover {
  color: #fff;
}
.menu-icons {
  margin-left: 8%;
  font-size: x-large;
}
.navigation {
  font-family: "Montserrat";
  z-index: 1001;
  width: 220px;
  min-width: 60px;
  height: 100%;
  top: 0;
  left: -160px;
  position: fixed;
  background-color: #d05959;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  transition: all 300ms ease-in-out;
  overflow-y: auto;

  &.nav-opened {
    width: 360px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  }

  .navigation-shell {
    width: 200px;
    height: 98%;
    position: absolute;
    right: 0;
    top: 0;

    .navigation-button {
      width: 100%;
      height: 40px;
      // position: relative;
      float: left;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;

      &.menu-button {
        height: 60px;
      }

      &:hover {
        .copy {
          opacity: 1;
        }

        .icon {
          opacity: 1;
        }
      }

      .copy {
        // width: auto;
        flex-grow: 1;
        text-align: left;
        font-size: 14px;
        color: #fff;
        // opacity: .4;
      }

      .icon {
        width: 60px;
        font-size: 30px;
        height: 100%;
        color: #fff;

        display: flex;
        align-items: center;
        justify-content: center;
        // opacity: .4;
      }
    }
  }

  #title {
    color: #fff;
    font-size: 23px;
    // padding-left: 7px;
    // margin-top: 20%;
    // padding-bottom: 10%;
    text-align: center;
    // border-bottom: 1px solid;
  }
}

.ellipses {
  // border-radius: 5px;
  border: 2px solid rgb(158, 56, 56);
  width: auto;
  min-width: 220px;
  height: auto;
  // min-height: 150px;
  position: fixed;
  background-color: #d05959;
  box-shadow: 6px 0px 10px -2px rgb(158, 56, 56);
  left: 60px;
  top: 285px;
  padding-left: 20px;
  // padding-top: 10px;
  padding-bottom: 10px;
  z-index: 1000000;
  font-size: 0.8rem;

  display: grid;
  // grid-template-rows: auto;
  // grid-template-columns: repeat(2, 1fr);
  grid-auto-columns: repeat(auto-fill, 1fr);
  grid-auto-rows: repeat(auto-fill, 1fr);
  // gap: 2px 10px;

  transition: all 300ms ease-in-out;

  &.nav-open {
    margin-left: 160px;
  }

  .ellipses-icons {
    font-family: 'Montserrat';
  }
}


</style>
